<div class="container cart-section">
    <div class="row" *ngIf="distributorInfo">
        <div class="col-xs-6 no-padding">
            <form [formGroup]='reportsFormGroup'>
                <div class="form-group col-md-3 half-width">
                    <label for="reportType">{{'common.Report type' |translate |translateKey}}
                    </label>
                    <select class="form-control ng-pristine ng-invalid ng-touched" [(ngModel)]="selectedReportType"
                        name="reportType" formControlName="reportType" (change)='assignReportNames()'>
                        <option [selected]='true' [ngValue]="1">{{reportTypeConstants.AgentPortalFBOReports}}</option>
                        <option *ngIf="distributorInfo.memberTypeId===memberTypeEnum.DISTRIBUTOR" [ngValue]="2">
                            {{reportTypeConstants.FBOReports}}
                        </option>
                        <option *ngIf="distributorInfo.memberTypeId===memberTypeEnum.DISTRIBUTOR" [ngValue]="3">
                            {{reportTypeConstants.FBOAccountPortalWidgets}}</option>
                    </select>
                </div>

                <div class="form-group col-md-3 half-width">
                    <label for="reportType">{{'common.Report Name' |translate |translateKey}}
                    </label>
                    <select class="form-control ng-pristine ng-invalid ng-touched" formControlName="reportName"
                        [(ngModel)]="selectedReportName">
                        <option *ngFor="let reportName of reportNames" [ngValue]="reportName"> {{reportName}} </option>
                    </select>
                </div>
            </form>
        </div>

        <div class="col-xs-6 no-padding">
            <div class="col-xs-8 text-right color-black full-width">
                <h2><b class=""> {{distributorInfo | displayNameFormat}} </b></h2>
            </div>
            <div *ngIf="distributorInfo && distributorInfo.displayName && distributorInfo.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="col-xs-8 text-right color-black full-width pad-b-7 bold">
                <span>{{distributorInfo.displayName | titlecase}}</span>
              </div>
            <div class="col-xs-6 text-right report-name full-width">
                <a *ngIf="fboid"><i class="fa fa-copy" [copyToClipboard]="fboid"></i></a>
                <span class="">{{fboid | distributorIdFormat}} </span> | <span
                    >{{distributorInfo.level}} </span>
            </div>
        </div>

        <div *ngIf="selectedReportName !== reportNameConstants.UplineReport && selectedReportName !== reportNameConstants.DownlineMapReport && selectedReportName !== reportNameConstants.ViewIncentives"
            class="text-center col-xs-12">
            <h1> Coming Soon... </h1>
            <!-- <app-view-incentives [fboid]="fboid" [homeCountryInfo]="homeCountryInfo"></app-view-incentives> -->
        </div>

        <div *ngIf="selectedReportName === reportNameConstants.ViewIncentives" class="text-center col-xs-12">
            <!-- <h1> Coming Soon... </h1> -->
            <app-incentives [fboid]="fboid" [homeCountryInfo]="homeCountryInfo"  [operatingCountryInfo]="operatingCountryInfo"></app-incentives>
        </div>
        <div *ngIf="selectedReportName=== reportNameConstants.UplineReport" class="col-xs-12">
            <upline [fboid]="fboid" [homeCountryInfo]="homeCountryInfo"></upline>
        </div>
        <div *ngIf="selectedReportName=== reportNameConstants.DownlineMapReport" class="col-xs-12">
            <app-downline-map [fboid]="fboid" [homeCountryInfo]="homeCountryInfo"
                [distributorInfo]="distributorInfo.name">
            </app-downline-map>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/master-reports.component.html